import { gql } from 'graphql-tag'
import { seoFragment } from '../fragments/seo.js'

export const modulisticaPage = gql`
  ${seoFragment}
  query ModulisticaPage($locale: SiteLocale) {
    paginaModulistica(locale: $locale) {
      seo {
        ...SeoFragment
      }
      titolo
      slug
      intro {
        titolo
      }
      modulistica {
        titolo
        id
        sezione {
          titolo
          id
          item {
            titolo
            testo
            id
            testo
            cta {
              testo
              link
              file {
                url
              }
            }
          }
        }
      }
    }
  }
`
